import type { FetchNotesFilters } from '@memorai/types';

export const queryKeys = {
    categories: ['categories'] as const,
    notes: (filters?: FetchNotesFilters) => ['notes', filters] as const,
    infiniteNotes: (filters?: FetchNotesFilters) => ['notes', 'infinite', filters] as const,
    note: (id?: string) => ['note', id] as const,
    preferences: (userId?: string) => ['preferences', userId] as const,
    user: (userId?: string) => ['user', userId] as const,
};
